// src/components/Loader.js
import React from 'react';

const Loader = () => {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        width: '100%',
        flexDirection: 'column',
      }}
    >
      <div
        style={{
          border: '8px solid #f3f3f3',        // Light grey
          borderTop: '8px solid #ff3d2e',     // Brand color
          borderRadius: '50%',
          width: '60px',
          height: '60px',
          animation: 'spin 1s linear infinite',
          marginBottom: '16px',
        }}
      ></div>
      <span style={{ fontSize: '18px', fontWeight: 'bold', color: '#ff3d2e' }}>
        Loading...
      </span>

      {/* Inline keyframes */}
      <style>
        {`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
      </style>
    </div>
  );
};

export default Loader;
